import React from 'react';
import styles from './BusinessIdeaPage.scss';

import cx from 'classnames';
import { validateCompanyName } from '@wix/branding-client-lib/dist/src/Validations/validateCompanyDetails';
import { Input, Fade, OnBoardingNext } from '@wix/branding-client-lib';

import { TransitionGroup } from 'react-transition-group';

class BusinessIdeaPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrors: false
    };
  }

  inputCreated = (element, inputType) => {
    this[inputType] = element;
  };

  componentDidMount() {
    this.focus('company');
  }

  focus(inputName) {
    this[inputName] && this[inputName].focus();
  }

  render() {
    const { businessIdea, onBusinessIdeaChange, t, onNext, placeHolderText, nextButtonText } = this.props;
    const companyNameErrorMessage = validateCompanyName(businessIdea, t('COMPANY_NAME_VALIDATION_EMPTY'));
    const hasErrors = companyNameErrorMessage;
    const { showErrors } = this.state;

    const _onNext = hasErrors
      ? () => this.setState({ showErrors: true })
      : (...args) => {
          onNext(...args);
        };

    return (
      <div>
        <div className={styles.container}>
          <form
            onSubmit={e => {
              e.preventDefault();
              _onNext();
            }}
          >
            <TransitionGroup>
              <Fade delay={200} key="1">
                <Input
                  dataAid="company-name-input"
                  ref={el => this.inputCreated(el, 'company')}
                  text={businessIdea}
                  onChange={e => onBusinessIdeaChange(e.target.value)}
                  placeholder={placeHolderText}
                  limit={20}
                  style="main"
                  showErrors={showErrors && companyNameErrorMessage}
                  errorMessage={companyNameErrorMessage}
                />
              </Fade>
            </TransitionGroup>
          </form>
        </div>
        <div className={cx(styles.bottomActions2, { [styles.expanded]: true })}>
          <TransitionGroup>
            <Fade delay={400} key="1">
              <OnBoardingNext onNext={_onNext} nextText={nextButtonText} bng={true} />
            </Fade>
          </TransitionGroup>
        </div>
      </div>
    );
  }
}

export default BusinessIdeaPage;
